// components/PrivateRoute.js
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('Laki_user_data')));
  const [isChecking, setIsChecking] = useState(true); // initially true
  const [isAuthorized, setIsAuthorized] = useState(false); // whether login succeeded

  useEffect(() => {
    async function checkUserFromURL() {
      const params = new URLSearchParams(location.search);
      const phone = params.get("Phonenumber");
      const IDProvider = params.get("IDPaymentProvider");

      if (phone && IDProvider) {
        try {
          const response = await fetch(`https://apiv2.mobileartsme.com/LoginWithoutPass?IDService=864&MSISDN=${phone}&IDProvider=${IDProvider}`);
          const data = await response.json();

          if (data.Error === 0 && data.Result.Description === "Subscription Active") {
            const userData = {
              ...data.Result,
              phone: phone
            };
            localStorage.setItem('Laki_user_data', JSON.stringify(userData));
            setUser(userData);
            setIsAuthorized(true);
          } else {
            console.warn("❌" , data.Result.Description);
            setIsAuthorized(false);
            window.location.href="/"
          }
        } catch (err) {
          console.error("❌ Error during fetch", err);
        } finally {
          setIsChecking(false);
        }
      } else {
        console.warn("❌ Missing phone or provider in URL");
        setIsChecking(false);
      }
    }

    if (!user && location.pathname === '/home') {
      checkUserFromURL();
    } else {
      setIsAuthorized(true); // already logged in
      setIsChecking(false);
    }
  }, [user, location.pathname, location.search]);

  if (isChecking) {
    return <div>Loading...</div>;
  }

  if (!user && !isAuthorized) {
    // ❌ User is not logged in and auto-login failed – stay here, render nothing or fallback
    return <div>Access Denied</div>; // Or null
  }

  // ✅ User is logged in or auto-login succeeded
  return children;
}
